"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReduxGlobalStateKeys_1 = require("./ReduxGlobalStateKeys");
exports.createReducer = function (getGlobalState, defineGlobalState, nodeKey, reducer) {
    var defineReducerObject = {};
    if (!getGlobalState(ReduxGlobalStateKeys_1.REDUX_REDUCER_DEFINE_STATE_KEY)) {
        defineGlobalState(ReduxGlobalStateKeys_1.REDUX_REDUCER_DEFINE_STATE_KEY, defineReducerObject);
    }
    else {
        defineReducerObject = getGlobalState(ReduxGlobalStateKeys_1.REDUX_REDUCER_DEFINE_STATE_KEY);
    }
    defineReducerObject[nodeKey] = reducer;
};
/**
 * This function already use in reduxController, don't need user call it agin
 * @param constroller [ReduxController]
 */
exports.attachReducerToController = function (controller) {
    var reducerObj = controller.getGlobalState(ReduxGlobalStateKeys_1.REDUX_REDUCER_DEFINE_STATE_KEY);
    if (reducerObj) {
        Object.keys(reducerObj).map(function (nodeKey) {
            controller.setValue(controller.reducers, nodeKey, reducerObj[nodeKey]);
        });
    }
};
exports.defineStateOperateAction = function (controller, getGlobalState, defineGlobalState) {
    if (controller) {
        controller.getGlobalState = getGlobalState;
        controller.defineGlobalState = defineGlobalState;
    }
};
exports.defineReducer = function (controller, nodeKey, reducer) {
    exports.createReducer(controller.getGlobalState, controller.defineGlobalState, nodeKey, reducer);
};
